import { createSlice } from '@reduxjs/toolkit'
import { UIContractState as Guarantee } from '../../@types/UIContractState'
import { UIContractWorkflowEvent as WorkflowEvent } from '@types'

type InitalStateType = {
  allGuarantees: Guarantee[]
  isLoading: boolean
  error: null
}
const initialState: InitalStateType = {
  allGuarantees: [],
  isLoading: true,
  error: null
}

const slice = createSlice({
  name: 'allGuarantees',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true
      state.allGuarantees = []
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },

    // GET Guarantees
    getAllGuaranteesSuccess(state, action) {
      state.isLoading = false
      state.allGuarantees = action.payload
      state.error = null
    },
    // Append Guarantee
    appendGuaranteeSuccess(state, action) {
      state.isLoading = false
      state.allGuarantees = updateGuaranteesAndReturn(state.allGuarantees, action.payload)
      state.error = null
    },

    appendPaperGuaranteeSuccess(state, action) {
      state.isLoading = false
      state.allGuarantees = updatePaperGuaranteesAndReturn(state.allGuarantees, action.payload)
      state.error = null
    },
    // Append Guarantee
    appendGuaranteeSuccessForWorkflow(state, action) {
      state.isLoading = false
      state.allGuarantees = updateGuaranteesAndReturnForWorkflow(
        state.allGuarantees,
        action.payload
      )
      state.error = null
    },
    appendPaperGuaranteeSuccessForWorkflow(state, action) {
      state.isLoading = false
      state.allGuarantees = updatePaperGuaranteesAndReturnForWorkflow(
        state.allGuarantees,
        action.payload
      )
      state.error = null
    },
    // CLEAR Guarantees
    clearGuarantees(state) {
      state.isLoading = false
      state.allGuarantees = []
      state.error = null
    }
  }
})

export const {
  getAllGuaranteesSuccess,
  hasError,
  startLoading,
  appendGuaranteeSuccess,
  appendPaperGuaranteeSuccess,
  appendGuaranteeSuccessForWorkflow,
  appendPaperGuaranteeSuccessForWorkflow,
  clearGuarantees
} = slice.actions

// Reducer
export default slice.reducer

const updateGuaranteesAndReturn = (allGx: Guarantee[], guarantee: Guarantee) => {
  let updatedGx: Guarantee[] = []
  const index = allGx.findIndex(
    (g) =>
      g?.TriContractState?.contractIdentifier ===
      guarantee?.TriContractState?.contractIdentifier
  )
  if (index >= 0) {
    allGx[index] = guarantee
    updatedGx = allGx
  } else {
    console.log('New Guarantee Created>>>>')
    updatedGx = [guarantee, ...allGx]
  }
  return updatedGx
}

const updateGuaranteesAndReturnForWorkflow = (allGx: Guarantee[], guarantee: Guarantee) => {
  let updatedGx: Guarantee[] = []
  const index = allGx?.findIndex(
    (g) =>
      g?.TriContractState?.contractIdentifier ===
      guarantee?.TriContractState?.contractIdentifier
  )
  if (index >= 0) {
    allGx[index] = {
      ...allGx[index],
      TriContractState: {
        state: guarantee?.TriContractState?.state,
        ...({ newExpires: guarantee?.TriContractState?.newExpires } &&
          guarantee?.TriContractState?.newExpires),
        ...({ newAmount: guarantee.TriContractState?.newAmount } &&
          guarantee?.TriContractState?.newAmount),
        newPurposeData: guarantee?.TriContractState?.newPurposeData,
        stateDisplay: guarantee?.TriContractState?.stateDisplay,
        ...allGx[index].TriContractState,
      },
      reference: guarantee?.reference !== undefined ? guarantee?.reference : allGx[index].reference,
      businessUnitActionContext: guarantee.businessUnitActionContext
    }
    updatedGx = allGx
  } else {
    console.log('New Guarantee Created>>>>')
    updatedGx = allGx?.length > 0  ? [guarantee, ...allGx]: [guarantee]
  }
  return updatedGx
}


const updatePaperGuaranteesAndReturnForWorkflow = (allGx: Guarantee[], workflow: WorkflowEvent) => {
  let updatedGx: Guarantee[] = []
  const index = allGx.findIndex(
    (g) =>
      g?.TriContractPaperRecord?.paperIdentifier ===
      workflow?.contractIdentifier
  )
  if (index >= 0) {
    allGx[index] = {

      TriContractPaperRecord: {
        paperData: {
          ...allGx[index]?.TriContractPaperRecord?.paperData,
          ...workflow,
        }
      }
    }
    updatedGx = allGx
  }
  return updatedGx
}

const updatePaperGuaranteesAndReturn = (allGx: Guarantee[] = [], guarantee?: Guarantee) => {
  if (!guarantee || !guarantee?.TriContractPaperRecord?.paperIdentifier) {
    console.error('Invalid guarantee provided.');
    return allGx;
  }

  const safeAllGx = Array.isArray(allGx) ? allGx : [];

  const index = safeAllGx.findIndex(
    (g) =>
      g?.TriContractPaperRecord?.paperIdentifier ===
      guarantee?.TriContractPaperRecord?.paperIdentifier
  );

  if (index >= 0) {
    const updatedGx = [...safeAllGx];
    updatedGx[index] = guarantee;
    return updatedGx;
  } else {
    console.log('New Paper Guarantee Created >>>>');
    return [guarantee, ...safeAllGx];
  }
};
